import styled from 'styled-components';

export default styled.div`
  position: absolute;
  outline: none;
  user-select: none;
`;
